import libraryIn from '../store/libraryIn.json';
import libraryOut from '../store/libraryOut.json';

export function KeyFrame(animation, banner) {
  var animationName = `${animation.name}_${animation.direction}_${animation.duration}_${animation.type.toUpperCase()}`;
  animationName += animation.loop > 1 ? `_iteration_${animation.loop}` : animation.loop === -1 ? `_iteration_infinite` : "";
  var key = `@keyframes ${animationName} {`;
  const arrayAnimations = animation.type.toLowerCase() === "in" ? libraryIn : libraryOut;
  try  {
    arrayAnimations.forEach(item => {
      if (animation.name.toLowerCase() === item.name.toLowerCase() && animation.type.toLowerCase() === item.type.toLowerCase()) {
        var cssItem = "\n";
        item.keyframe.forEach(element => {
          cssItem += element;
        });
        if (animation.type.toLowerCase() === "in") {
          if (animation.direction.toLowerCase() === "left") {
            cssItem = cssItem.replace("$left$", item.value ? item.value : banner.width * 2);
            cssItem = cssItem.replace("$top$", 0);
          } else if (animation.direction.toLowerCase() === "right") {
            cssItem = cssItem.replace("$left$", item.value ? -item.value : -banner.width * 2);
            cssItem = cssItem.replace("$top$", 0);
          } else if (animation.direction.toLowerCase() === "top") {
            cssItem = cssItem.replace("$top$", item.value ? item.value : banner.height * 2);
            cssItem = cssItem.replace("$left$", 0);
          } else {
            cssItem = cssItem.replace("$top$", item.value ? -item.value : -banner.height * 2);
            cssItem = cssItem.replace("$left$", 0);
          }
        } else {
          if (animation.direction.toLowerCase() === "left") {
            cssItem = cssItem.replace("$left$", item.value ? -item.value : -banner.width * 2);
            cssItem = cssItem.replace("$top$", 0);
          } else if (animation.direction.toLowerCase() === "right") {
            cssItem = cssItem.replace("$left$", item.value ? item.value : banner.width * 2);
            cssItem = cssItem.replace("$top$", 0);
          } else if (animation.direction.toLowerCase() === "top") {
            cssItem = cssItem.replace("$top$", item.value ? -item.value : -banner.height * 2);
            cssItem = cssItem.replace("$left$", 0);
          } else {
            cssItem = cssItem.replace("$top$", item.value ? item.value : banner.height * 2);
            cssItem = cssItem.replace("$left$", 0);
          }
        }
        key += cssItem + "\n}\n";
        key += "\n";
        key += `.${animationName} {
          ${item.opacity ? "opacity: 1;\n" : ""}
          animation: ${animationName} ${animation.duration}ms ${item.animation} ${animation.type.toLowerCase() === "out" ? "!important" : "" };
          ${animation.loop === -1 ? "animation-iteration-count: infinite;" : animation.loop > 1 ? `animation-iteration-count: ${animation.loop};` : ""}
        }\n`
      }
    });
  } catch(error) {
    return "";
  }
  return key;
}

export function BuildAnimationPreview(element, type) {
  if (!element) return null;
  var animation = type === "in" ? element.animation.in : element.animation.out;
  return Keyframe({name: animation.animation, direction: animation.direction, type: type, duration: animation.duration, loop: 1});
}

export function buildKeyframes(banner) {
  var listAnimation = [];
  var keyframes = "<style>";
  banner.preset.forEach(element => {
    if (!element.customKeyframe) {
      listAnimation =
        AddArray(
          listAnimation,
          {
            name: element.animation,
            direction: element.direction,
            type: element.type,
            duration: element.duration,
            loop: element.loop
          }
        );
    }
  });

  if (banner.customKeyframe)
    banner.customKeyframe.forEach(custom => {
      keyframes += custom.keyframe;
    });

  listAnimation.forEach(animation => {
    keyframes += KeyFrame(animation, banner);
  });
  return keyframes + "</style>";
}

export function Keyframe(animation) {
  var key =  "@keyframes ";
  const arrayAnimations = animation.type.toLowerCase() === "in" ? libraryIn : libraryOut;
  var animationName = `${animation.name}_${animation.direction}_${animation.duration}_${animation.type.toUpperCase()}`;
  key += animationName + " {\n";
  try  {
    arrayAnimations.forEach(item => {
      if (animation.name === item.name && animation.type === item.type) {
        var cssItem = "\n";
        item.keyframe.forEach(element => {
          cssItem += element;
        });
        if (animation.type.toLowerCase() === "in") {
          if (animation.direction.toLowerCase() === "left") {
            cssItem = cssItem.replace("$left$", item.value ? item.value : 240 * 2);
            // cssItem = cssItem.replace("$left$", 240 * 2);
            cssItem = cssItem.replace("$top$", 0);
          } else if (animation.direction.toLowerCase() === "right") {
            cssItem = cssItem.replace("$left$", item.value ? -item.value : -240 * 2);
            // cssItem = cssItem.replace("$left$", -240 * 2);
            cssItem = cssItem.replace("$top$", 0);
          } else if (animation.direction.toLowerCase() === "top") {
            cssItem = cssItem.replace("$top$", item.value ? item.value : 160 * 2);
            // cssItem = cssItem.replace("$top$", 160 * 2);
            cssItem = cssItem.replace("$left$", 0);
          } else {
            cssItem = cssItem.replace("$top$", item.value ? -item.value : -160 * 2);
            // cssItem = cssItem.replace("$top$", -160 * 2);
            cssItem = cssItem.replace("$left$", 0);
          }
        } else {
          if (animation.direction.toLowerCase() === "left") {
            cssItem = cssItem.replace("$left$", item.value ? -item.value : -240 * 2);
            // cssItem = cssItem.replace("$left$", -240 * 2);
            cssItem = cssItem.replace("$top$", 0);
          } else if (animation.direction.toLowerCase() === "right") {
            cssItem = cssItem.replace("$left$", item.value ? item.value : 240 * 2);
            // cssItem = cssItem.replace("$left$", 240 * 2);
            cssItem = cssItem.replace("$top$", 0);
          } else if (animation.direction.toLowerCase() === "top") {
            cssItem = cssItem.replace("$top$", item.value ? -item.value : -160 * 2);
            // cssItem = cssItem.replace("$top$", -160 * 2);
            cssItem = cssItem.replace("$left$", 0);
          } else {
            cssItem = cssItem.replace("$top$", item.value ? item.value : 160 * 2);
            // cssItem = cssItem.replace("$top$", 160 * 2);
            cssItem = cssItem.replace("$left$", 0);
          }
        }
        key += cssItem + "\n}\n";
        key += "\n";
        key += `.${animationName} {
          animation: ${animationName} ${animation.duration}ms ${item.animation} ${animation.type === "out" ? "!important" : "" };
        }\n`
      }
    });
  } catch(error) {
    return "";
  }
  return {style: key, name: animationName}
}

function AddArray (array, item) {
  var aux = true;
  array.forEach(element => {
    if (`${element.name}${element.direction}${element.type}${element.duration}${element.loop}` === `${item.name}${item.direction}${item.type}${item.duration}${item.loop}`) {
      aux = false;
    }
  });
  if (aux) {
      array.push(item)
  }
  
  return array;
}


